import {faTrashAlt} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

import {extractProps} from '../../utils/propUtils';

const propTypes = {
  className: PropTypes.string,
};

/**
 * Renders FontAwesome trash icon.
 *
 * @param {object} props - props container
 * @param {string} props.className
 * @return {ReactElement}
 */
export default function TrashIcon({className, ...otherProps}) {
  return (
    <FontAwesomeIcon
      icon={faTrashAlt}
      className={className}
      {...extractProps(otherProps)}
    />
  );
}
TrashIcon.propTypes = propTypes;
